// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".questionnaire-list .questionnaire-list-content[data-v-a118c936]{padding-right:20px}.questionnaire-list .option-button[data-v-a118c936]{cursor:pointer;color:#df5813}", ""]);
// Exports
module.exports = exports;
